module.exports = "<iframe style=\"border: 0\" [src]=\"url\" width=\"100%\" height=\"100%\"></iframe>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/external-billing/external-processed-claims/external-processed-claims.component.html
// module id = 2446
// module chunks = 66